import { render, staticRenderFns } from "./BlogArticleView.vue?vue&type=template&id=5b4a1e11&scoped=true"
import script from "./BlogArticleView.vue?vue&type=script&lang=js"
export * from "./BlogArticleView.vue?vue&type=script&lang=js"
import style0 from "./BlogArticleView.vue?vue&type=style&index=0&id=5b4a1e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4a1e11",
  null
  
)

export default component.exports